export const language: any = {
  add_by_image: "Als Foto hinzufügen",
  add_image_by_camera: "Mit der Kamera fotografieren",
  add_image_by_gallery: "Foto auswählen",
  loading: "Wir bereiten ein köstliches Rezept vor.\nBitte haben Sie einen Moment Geduld.",
  retry: "Erneut versuchen",
  cancel: "Abbrechen",
  yes: "Ja",
  no: "Nein",
  goToIngredient: "Zutaten analysieren",
  goToRecipe: "Gericht analysieren",
  recipe: {
    title: "KI-Rezept",
    analysis_results: "Analyseergebnisse",
    ingredients: {
      title: "Zutaten (1 Portion)",
      view_more: "Mehr anzeigen",
      view_less: "Weniger anzeigen",
    },
    how_to_cook: "Zubereitungsmethode",
    go_to_detail: "KI-Rezept anzeigen",
    description: "Rezeptbeschreibung",
    calories: "Kalorien",
    time: "Kochzeit",
    ingredient: "Hauptzutaten",
    spice: "Gewürze",
    tip: "TIPP",
  },
  ingredient: {
    title: "Fotoanalyse",
    analysis_results: "Die Fotoanalyse ergab folgende Zutaten.",
    add_to_cart: "Zum Warenkorb hinzufügen",
    add_to_my_ingredients: "Zutaten hinzufügen",
  },
  msg: {
    not_ingredients: `Das ist ein tolles Foto,\naber hier dreht sich alles um Zutaten!\nNächstes Mal fangen Sie doch leckere Zutaten ein –\ndie Geheimnisse des Kochens warten auf Sie!\nMöchten Sie zum KI-Koch gehen?`,
    not_recipes: `Nun, das ist kein Gericht!\nWir können nur Fotos von Gerichten analysieren.\nBitte laden Sie ein Foto vom fertigen Gericht hoch.\nMöchten Sie die Zutaten analysieren?`,
    not_found: "Nicht gefunden",
    unknow: `Ich glaube nicht, dass es sich um ein Foto eines Gerichts oder von Zutaten handelt.\nBitte laden Sie ein Foto Ihres Gerichts\noder Ihrer Zutaten zur Analyse hoch.\nDann können wir Ihnen besser helfen!`,
    upload_fail: `Der Upload ist aufgrund eines vorübergehenden Fehlers fehlgeschlagen.\nBitte versuchen Sie es in einem Moment erneut.`,
    error: `Oh! Die Fotoanalyse war nicht erfolgreich.\nWählen Sie ein anderes Bild aus oder\nsollen wir ein klareres Bild versuchen?`,
    bothType: `Auf dem Foto sind sowohl Zutaten als auch ein Gericht!\nBitte wählen Sie aus, was Sie analysieren möchten.`,
  },
};
